var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZorgtoeslagGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.76 249.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #d5d1c1;\n      }\n\n      .cls-4 {\n        fill: #455a64;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-14);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-10 {\n        font-family: BlambotProBB-Bold, 'Blambot Pro BB';\n        font-size: 8px;\n        font-weight: 700;\n      }\n\n      .cls-10, .cls-11 {\n        fill: #263238;\n      }\n\n      .cls-12 {\n        fill: #e7d7ba;\n      }\n\n      .cls-13 {\n        fill: #767676;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-15 {\n        fill: #ebebeb;\n      }\n\n      .cls-16 {\n        fill: #ffc727;\n      }\n\n      .cls-17 {\n        opacity: .1;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.98,
    y1: 156.22,
    x2: 188.85,
    y2: 156.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef7e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 246.34,
    x2: 191.71,
    y2: 246.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c927f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.05,
    y1: 60.57,
    x2: 191.76,
    y2: 60.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 13.97,
    y1: 2.8,
    x2: 177.86,
    y2: 2.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 18.12,
    y1: 31.62,
    x2: 173.72,
    y2: 31.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 25.33,
    y1: 28.04,
    x2: 38.45,
    y2: 28.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 32.65,
    y1: 21.04,
    x2: 45.76,
    y2: 21.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 25.33,
    y1: 28.04,
    x2: 38.45,
    y2: 28.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 32.65,
    y1: 42.01,
    x2: 45.76,
    y2: 42.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 110.96,
    y1: 42.01,
    x2: 124.08,
    y2: 42.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 146.07,
    y1: 21.4,
    x2: 159.18,
    y2: 21.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 138.75,
    y1: 14.51,
    x2: 151.87,
    y2: 14.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 53.44,
    y1: 204.96,
    x2: 55.59,
    y2: 204.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 171.81,
    y1: 63.62,
    x2: 128.9,
    y2: 54.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-3--inject-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 2.98,
    y: 63.29,
    width: 185.86,
    height: 185.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 243.54,
    width: 191.71,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.05,
    y: 57.77,
    width: 191.71,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.01,
    y: 225.15,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 10.7,
    y: 232.14,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.33,
    y: 232.14,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 160.7,
    y: 232.14,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 160.7,
    y: 74.75,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 168.02,
    y: 81.74,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 10.7,
    y: 74.76,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 52.38,
    y: 134.87,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 59.7,
    y: 127.9,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 13.97,
    width: 163.88,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 18.12,
    y: 5.48,
    width: 155.6,
    height: 52.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 25.33,
    y: 25.26,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 32.65,
    y: 18.27,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 25.33,
    y: 25.26,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 32.65,
    y: 39.24,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 110.96,
    y: 39.24,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.07,
    y: 18.62,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 138.75,
    y: 11.74,
    width: 13.11,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.16,
    y: 13.99,
    width: 23.03,
    height: 35.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 38.04,
    y: 15.86,
    width: 19.28,
    height: 31.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "56.78 15.86 38.04 34.6 38.04 20.5 42.67 15.86 56.78 15.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.33 40.19 57.33 47.39 50.12 47.39 57.33 40.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.33 34.01 57.33 36.98 46.92 47.39 43.95 47.39 57.33 34.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "39.69 15.86 38.04 17.51 38.04 15.86 39.69 15.86"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 38.04,
    y: 37.31,
    width: 19.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.39,
    y: 13.99,
    width: 23.03,
    height: 35.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.27,
    y: 15.86,
    width: 19.28,
    height: 31.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.01 15.86 86.27 34.6 86.27 20.5 90.9 15.86 105.01 15.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.56 40.19 105.56 47.39 98.35 47.39 105.56 40.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.56 34.01 105.56 36.98 95.16 47.39 92.18 47.39 105.56 34.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "87.92 15.86 86.27 17.51 86.27 15.86 87.92 15.86"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.27,
    y: 37.31,
    width: 19.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.64,
    y: 13.99,
    width: 23.03,
    height: 35.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 134.51,
    y: 15.86,
    width: 19.28,
    height: 31.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "153.25 15.86 134.51 34.6 134.51 20.5 139.15 15.86 153.25 15.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "153.81 40.19 153.81 47.39 146.6 47.39 153.81 40.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "153.81 34.01 153.81 36.98 143.4 47.39 140.43 47.39 153.81 34.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "136.16 15.86 134.51 17.51 134.51 15.86 136.16 15.86"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.51,
    y: 37.31,
    width: 19.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.66,
    y: 145.26,
    width: 44.4,
    height: 103.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.26,
    y: 152.03,
    width: 31.19,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.45 152.03 51.45 158.18 20.26 189.37 20.26 174.6 42.82 152.03 51.45 152.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.45 184.26 51.45 199.03 28.51 222.02 20.26 222.02 20.26 215.5 51.45 184.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.45 177.78 51.45 180.9 20.26 212.14 20.26 209.01 51.45 177.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "39.69 152.03 20.26 171.45 20.26 165.34 33.57 152.03 39.69 152.03"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 53.44,
    y: 199.12,
    width: 2.15,
    height: 11.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 20.26,
    y: 202.48,
    width: 31.19,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.1,
    y: 145.26,
    width: 108.02,
    height: 78.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.17,
    y: 148.33,
    width: 101.88,
    height: 72.53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.04 200.34 175.04 215.1 169.29 220.86 154.51 220.86 175.04 200.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.86 148.33 73.17 211.02 73.17 196.24 121.09 148.33 135.86 148.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "145.07 148.33 73.17 220.23 73.17 217.1 141.95 148.33 145.07 148.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.04 176.58 175.04 179.68 133.87 220.86 130.75 220.86 175.04 176.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.04 220.73 175.04 220.86 174.91 220.86 175.04 220.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.28 148.33 73.17 183.44 73.17 177.33 102.17 148.33 108.28 148.33"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 65.65,
    y: 175.51,
    width: 114.5,
    height: 18.29,
    transform: "translate(-31.34 25.24) rotate(-10.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m99.82,193.05c-.41-2.5,1.28-4.86,3.78-5.28,1.04-.2,2.11-.04,3.05.44.34.19.47.61.29.95-.18.35-.61.49-.96.32-.65-.34-1.4-.46-2.13-.32-.84.16-1.58.64-2.09,1.32-.97,1.37-.65,3.26.72,4.23.01.01.03.02.04.03.72.44,1.57.61,2.4.48.73-.12,1.39-.49,1.89-1.03.29-.26.73-.26,1.02,0,.26.28.26.72,0,1-.7.76-1.63,1.28-2.64,1.48-2.48.47-4.88-1.14-5.38-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m110.34,195.01l-1.32-7.24c-.06-.37.19-.73.56-.79,0,0,0,0,0,0,.37-.07.73.17.8.55,0,0,0,0,0,0l1.18,6.6,3.38-.61c.35-.15.75.02.9.37.15.35-.02.75-.37.9-.09.04-.19.06-.29.05l-4.03.73h0c-.37.08-.74-.16-.81-.53,0-.01,0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m122.38,185.8c1.98,1.43,2.48,4.17,1.11,6.19-.63.96-1.62,1.63-2.75,1.85-1.15.2-2.33-.08-3.28-.77-.95-.69-1.59-1.72-1.8-2.88-.21-1.15.03-2.34.69-3.31.63-.98,1.65-1.66,2.8-1.86,1.14-.2,2.3.08,3.22.78Zm.38,3.13c-.14-.8-.58-1.51-1.23-1.99-1.21-.91-2.94-.67-3.85.55-.04.05-.08.11-.12.17-.91,1.41-.58,3.28.77,4.28,1.2.91,2.92.68,3.83-.52.05-.06.09-.12.13-.19.43-.68.58-1.5.41-2.28h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m126.58,190.59c.18-.31.58-.42.9-.25.77.44,1.67.62,2.55.52.55-.08,1.07-.34,1.47-.73.28-.25.43-.62.38-.99-.03-.14-.09-.27-.18-.37-.12-.13-.27-.23-.44-.29-.58-.2-1.19-.3-1.81-.28h0c-.57,0-1.14-.07-1.69-.2-.5-.12-.96-.38-1.32-.74-.24-.27-.4-.61-.46-.96-.1-.73.15-1.46.67-1.97.56-.54,1.27-.9,2.03-1.03.99-.13,2,.04,2.89.49.32.14.47.52.33.85-.13.32-.5.48-.82.35,0,0-.01,0-.02,0-.66-.36-1.41-.51-2.15-.42-.5.08-.96.31-1.32.66-.24.22-.37.54-.33.86.02.12.07.24.15.33.12.11.25.19.4.25.53.2,1.09.29,1.65.26h0c.61-.01,1.22.05,1.81.2.54.13,1.03.4,1.43.79.25.28.42.62.49.99.12.77-.16,1.55-.73,2.09-.59.6-1.35.99-2.18,1.12-1.18.15-2.37-.08-3.41-.66-.31-.16-.43-.54-.28-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m135.29,190.52l-1.32-7.22c-.08-.36.15-.71.51-.78.02,0,.03,0,.05,0h0l4.03-.73c.38,0,.68.32.67.7,0,.27-.17.52-.42.62l-3.37.61.4,2.25,2.91-.53c.37-.06.73.19.81.55.06.38-.19.74-.57.81l-2.91.53.41,2.26,3.38-.61c.35-.15.75.02.9.37.15.35-.02.75-.37.9-.09.04-.19.06-.29.05l-4.03.71h0c-.34.06-.68-.14-.78-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m142.52,189.23l-1.32-7.17c-.07-.37.17-.72.53-.79,0,0,.01,0,.02,0l1.48-.26c2.35-.53,4.68.94,5.22,3.28.53,2.35-.94,4.68-3.28,5.22-.13.03-.27.05-.4.07l-1.47.26c-.38.05-.72-.21-.78-.58,0,0,0-.02,0-.02Zm1.32-.94l.78-.15c1.62-.29,2.69-1.84,2.4-3.45-.29-1.62-1.84-2.69-3.45-2.4l-.77.13,1.04,5.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "83.42 186.77 76.84 206.61 73.88 207.14 80.47 187.3 83.42 186.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "90.23 185.54 83.64 205.38 80.69 205.91 87.28 186.07 90.23 185.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "167.52 171.66 160.93 191.5 157.99 192.03 164.58 172.19 167.52 171.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "174.33 170.44 167.74 190.27 164.81 190.8 171.4 170.96 174.33 170.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 65.65,
    y: 175.51,
    width: 114.5,
    height: 18.29,
    transform: "translate(-31.34 25.24) rotate(-10.41)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "83.42 186.77 76.84 206.61 73.88 207.14 80.47 187.3 83.42 186.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "90.23 185.54 83.64 205.38 80.69 205.91 87.28 186.07 90.23 185.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "167.52 171.66 160.93 191.5 157.99 192.03 164.58 172.19 167.52 171.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "174.33 170.44 167.74 190.27 164.81 190.8 171.4 170.96 174.33 170.44"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(93 193.57) rotate(-9.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "gesloten"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 95.88,
    cy: 104.74,
    rx: 76.77,
    ry: 26.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m95.88,126.89c-39.62,0-71.89-9.94-71.89-22.15s32.25-22.16,71.89-22.16,71.89,9.94,71.89,22.16-32.24,22.15-71.89,22.15Zm0-43.98c-39.45,0-71.56,9.79-71.56,21.83s32.11,21.84,71.56,21.84,71.56-9.79,71.56-21.82-32.09-21.86-71.56-21.86h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.83,101.54l-4.19,4.49h4.19v2.15h-7.84v-2.15l4.18-4.49h-4.18v-2.15h7.84v2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.59,103.79c0-2.97,1.89-4.54,4.73-4.54s4.71,1.58,4.71,4.54-1.89,4.54-4.71,4.54-4.73-1.58-4.73-4.54Zm4.73,2.38c1.08,0,1.85-.82,1.85-2.38,0-1.55-.78-2.38-1.85-2.38s-1.88.83-1.88,2.38.78,2.38,1.88,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.98,103.55v4.64h-2.86v-8.79h2.86v1.15c.52-.87,1.4-1.3,2.54-1.3v2.19c-1.71-.08-2.54.87-2.54,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.35,99.39v7.68c0,3-2.09,4.4-4.65,4.4-2.41,0-4.29-1.34-4.54-3.59h2.85c.19,1.01.82,1.47,1.69,1.47,1.1,0,1.8-.74,1.8-2.33v-.87c-.57.88-1.46,1.29-2.66,1.29-2.27,0-3.94-1.62-3.94-3.99s1.64-4.19,3.91-4.19c1.18,0,2.1.42,2.69,1.33v-1.19h2.85Zm-4.74,5.96c1.1,0,1.82-.82,1.82-1.91s-.72-1.97-1.82-1.97-1.86.78-1.86,1.95.72,1.93,1.86,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.79,99.39h2.42v2.23h-2.42v3.17c0,.82.29,1.2.93,1.2h1.49v2.19s-2.79,0-2.79,0c-1.68,0-2.48-.99-2.48-2.65v-3.92h-1.44v-2.23h.82c.44,0,.53-.24.62-.67l.18-1.35h2.68v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m89.99,103.79c0-2.97,1.89-4.54,4.73-4.54s4.71,1.58,4.71,4.54-1.89,4.54-4.71,4.54-4.73-1.58-4.73-4.54Zm4.73,2.38c1.08,0,1.85-.82,1.85-2.38,0-1.55-.78-2.38-1.85-2.38s-1.88.83-1.88,2.38.78,2.38,1.88,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,101.66c.35.77.5,1.69.45,2.7h-6.55c.17,1.2.89,1.85,1.85,1.85.78,0,1.46-.41,1.68-1.29h2.85c-.35,2.25-2.19,3.41-4.53,3.41-2.85,0-4.74-1.58-4.74-4.54s1.89-4.54,4.75-4.54c2.08,0,3.56.91,4.25,2.41Zm-2.5,1.18c-.02-.14-.06-.27-.1-.4-.26-.74-.86-1.14-1.65-1.14-.9,0-1.54.54-1.79,1.54h3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.01,101.02c-.87,0-1.39.32-1.37.77.04.53.7.82,1.91,1.03,2.68.49,3.78,1.08,3.78,2.66,0,1.85-1.79,2.85-4.39,2.84-2.61,0-4.32-.86-4.26-2.89h2.76c-.06.64.58,1.07,1.56,1.07.92,0,1.48-.39,1.42-.91-.07-.58-1.2-.84-2.81-1.18-1.82-.39-2.85-1.18-2.85-2.63,0-1.7,1.67-2.55,4.2-2.53,2.34,0,4.2.87,4.14,2.76h-2.76c.02-.62-.5-.99-1.33-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m123.3,108.18h-2.86v-11.7h2.86v11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134,99.39v8.79h-2.86v-1.28c-.53.94-1.43,1.42-2.69,1.42-2.27,0-3.91-1.7-3.91-4.53s1.64-4.53,3.91-4.53c1.22,0,2.13.47,2.69,1.41v-1.27h2.86Zm-4.74,6.71c1.04,0,1.84-.85,1.84-2.31,0-1.46-.79-2.31-1.84-2.31s-1.86.82-1.86,2.31.78,2.31,1.86,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m144.54,99.39v7.68c0,3-2.09,4.4-4.65,4.4-2.41,0-4.29-1.34-4.54-3.59h2.85c.19,1.01.82,1.47,1.69,1.47,1.1,0,1.8-.74,1.8-2.33v-.87c-.57.88-1.46,1.29-2.66,1.29-2.27,0-3.94-1.62-3.94-3.99s1.64-4.19,3.91-4.19c1.18,0,2.1.42,2.69,1.33v-1.19h2.85Zm-4.74,5.96c1.1,0,1.82-.82,1.82-1.91s-.72-1.97-1.82-1.97-1.86.78-1.86,1.95.72,1.93,1.86,1.93Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "191.76 63.37 191.76 57.77 173.72 57.77 173.72 5.6 177.86 5.6 177.86 0 13.97 0 13.97 5.6 18.12 5.6 18.12 57.77 .05 57.77 .05 63.37 2.98 63.37 2.98 243.54 0 243.54 0 249.14 2.98 249.14 2.98 249.15 188.85 249.15 188.85 249.14 191.71 249.14 191.71 243.54 188.85 243.54 188.85 63.37 191.76 63.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.65,52.39l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m154.56,69.16c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorgtoeslagGesloten);
export default __webpack_public_path__ + "static/media/zorgtoeslag-gesloten.4a41b62f0860d27e61875ad335c1d2f9.svg";
export { ForwardRef as ReactComponent };